
import { MdClose } from "react-icons/md";

const MultiselectValue = ({value, onDeselect}) => {
    return <div className="modal-tag">
        <span>{value}</span> 
        <MdClose 
            className="modal-tag-remove clear-tag"
            data-testid="modal-tag-remove"
            onClick={(e) => {
                e.stopPropagation();
                onDeselect();
            }}
        >X</MdClose>
    </div>;
}

export default MultiselectValue;